$(() => {
  const slider = $('.helpful-links-slider');
  const nextArrow = $('#helpful-links-slider-next-arrow');
  const prevArrow = $('#helpful-links-slider-prev-arrow');

  slider.slick({
    slidesToShow: 1,
    mobileFirst: true,
    infinite: true,
    nextArrow,
    prevArrow,
  });
  const refresh = () => {
    slider.slick('setPosition');
    slider.slick('refresh');
  };

  $(window).on('resize', refresh);
  $(window).on('load', refresh);
});
